/**
 * Identity of the text an AI-assist analysis was run against.
 *
 * The assist reuses earlier completed executions for a role (looked up by
 * system reference and factor) instead of paying for the analysis again. That
 * lookup knew nothing about WHICH document text the execution had analysed, so
 * after a new upload on the same role it handed back evidence sentences from
 * the previous document — "6 matches found" and nothing to highlight, and a
 * rationale draft grounded on text the evaluator cannot see.
 *
 * Each trigger now stamps `text_hash` into `source_data.custom`, and the
 * lookup only reuses executions carrying the same hash. Whitespace is
 * collapsed first so a re-render of the same document (different line
 * wrapping, trailing spaces) still matches.
 *
 * FNV-1a 32-bit, hex. Not cryptographic — it only has to separate one document
 * from another for the same role, and it has to be cheap and identical in
 * both portals.
 */
export function sourceTextHash(text) {
  const s = String(text == null ? '' : text).replace(/\s+/g, ' ').trim();
  if (!s) return null;
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h.toString(16).padStart(8, '0');
}
